<template>
  <div class="header">
    <div class="header-container">
      <div class="container">
        <div class="logo-wrapper">
          <a class="logo" href="/" alt="中数链"></a>
          <p class="logo-text">中国数字文化链</p>
        </div>
        <div class="menus">
          <a class="menu-item" href="/" :class="{ active: from === 'home' }"
            >首页
          </a>
          <a
            class="menu-item"
            :class="{ active: from === 'index' }"
            href="/index"
          >
            中国数字文化链浏览器
          </a>
          <a
            class="menu-item"
            href="https://copyright.cdcee.net/#/login/child_login"
            target="_blank"
            >版权保护</a
          >
        </div>
        <el-dropdown class="phone-menu" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="icon-menu"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="d">
              <a class="link-con" :class="{ active: from === 'home' }" href="/"
                >中数链
              </a>
            </el-dropdown-item>
            <el-dropdown-item command="a">
              <a
                class="link-con"
                :class="{ active: from === 'index' }"
                href="/index"
                >中国数字文化链浏览器
              </a>
            </el-dropdown-item>
            <el-dropdown-item command="e">
              <a
                class="link-con"
                href="https://copyright.cdcee.net/#/login/child_login"
                target="_blank"
                >版权保护
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="header-placeholder"></div>
  </div>
</template>
<script>
export default {
  name: "page-header",
  props: {
    from: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    handleCommand() {}
  }
};
</script>
<style scoped>
.header-container {
  background: #00162a;
  position: fixed;
  height: 64px;
  line-height: 64px;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
  /* border-bottom: 1px solid #E6E6E6; */
  box-shadow: 0px 4px 15px 0px rgba(38, 62, 79, 0.2);
}

.header-placeholder {
  height: 64px;
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  height: 64px;
}

.header .logo {
  flex-shrink: 0;
  margin-right: 10px;
}

.header .menus {
  display: flex;
  align-items: center;
}
.header .phone-menu {
  display: none;
}
.header .menus :nth-child(2) {
  position: relative;
}

.header .menus :nth-child(2) .did {
  color: #999;
}

.header .menus :nth-child(2) .did i {
  position: relative;
  top: -3px;
  left: 5px;
  border: 3px solid #999;
  border-width: 0px 1px 1px 0px;
  display: inline-block;
  padding: 4px;
}

.menus :nth-child(2) .did .down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.menus .menu-item:nth-child(2):hover .domain {
  display: block;
}

.menus .menu-item:nth-child(2) .domain:hover {
  color: #66b1ff;
}

.header .menus :nth-child(2) .domain {
  display: none;
  width: 100%;
  position: absolute;
  line-height: 64px;
  box-sizing: border-box;
  padding: 0 23px;
  background: #f6fbff;
  height: 64px;
  bottom: -47px;
  left: 0;
  border-radius: 0 0 4px 4px;
  text-align: center;
  z-index: 100;
}

.header .menus .menu-item {
  position: relative;
  /* margin-right: 46px; */
  height: 64px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
  padding: 0 23px;
}

.header .menus .menu-item .down-menus {
  display: none;
  position: absolute;
  left: 0;
  top: 60px;
  width: auto;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  min-width: 110px;
}

.header .menus .menu-item .down-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 10px;
  color: #000;
}

.header .menus .menu-item .down-menu-item + .down-menu-item {
  border-top: 1px solid #f6f6f6;
}

.header .menus .menu-item:hover .down-menus {
  display: block;
}

.header .menus .menu-item.active {
  color: #fff;
}
.header .menus .menu-item.active::after {
  content: "";
  height: 2px;
  width: 60%;
  position: absolute;
  bottom: 0;
  left: 20%;
  background: #fff;
  border-radius: 4px;
}
.icon-menu {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}
.icon-menu::before,
.icon-menu::after {
  position: absolute;
  content: "";
  left: 0;
  width: 16px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}
.icon-menu::before {
  top: -5px;
}
.icon-menu::after {
  top: -10px;
}

@media (max-width: 1199px) {
  .header .container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .header .menus {
    display: none;
  }

  .header .phone-menu {
    display: block;
  }

  .header .el-dropdown {
    color: #fff !important;
    font-size: 16px;
  }
}
@media (max-width: 800px) {
  .header .container {
    padding: 0 10px;
  }
  .header .logo-text {
    display: none;
  }
  .link-con {
    color: #333;
    display: block;
  }
  .link-con.active {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page-header.vue